import { render, staticRenderFns } from "./InitialsCarprof.vue?vue&type=template&id=478f9c0f"
import script from "./InitialsCarprof.vue?vue&type=script&lang=js"
export * from "./InitialsCarprof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports